import { parseNumberInput } from "@/lib/parse-number";

const LINE_BREAK = /\r?\n/;
const SEMICOLON_SEPARATORS = /[\s;]+/;
const COMMA_SEPARATORS = /[\s,]+/;

/** Most cash flows accepted — keeps the IRR search's powers of (1 + r) finite. */
export const MAX_FLOWS = 100;

export interface ParsedFlows {
  flows: number[];
  /** The first piece of text that is not a number, if any. */
  invalid: string | null;
}

/**
 * Cash flows from pasted text. One per line is the form a spreadsheet column pastes as;
 * without line breaks a list on one line is split like `parseNumberList` does, so a
 * semicolon frees the comma to be a decimal mark.
 */
export function parseCashFlows(raw: string): ParsedFlows {
  const text = raw.trim();
  let tokens: string[];
  if (text.includes("\n")) {
    tokens = text.split(LINE_BREAK);
  } else if (text.includes(";")) {
    tokens = text.split(SEMICOLON_SEPARATORS);
  } else {
    tokens = text.split(COMMA_SEPARATORS);
  }
  const flows: number[] = [];
  for (const token of tokens) {
    const piece = token.trim();
    if (piece === "") {
      continue;
    }
    const value = parseNumberInput(piece);
    if (value === null) {
      return { flows, invalid: piece };
    }
    flows.push(value);
  }
  return { flows, invalid: null };
}
